import { whenAll } from 'platform/shared/health-apps';
import content from '../../../locales/en/content.json';
import {
  hasDifferentMailingAddress,
  hasNoSharedAddress,
  hasPrimaryCaregiver,
} from '../../../utils/helpers';
import addressSelection from './addressSelection';
import contactInformation from './contactInformation';
import hasPrimary from './hasPrimary';
import homeAddress from './homeAddress';
import identityInformation from './identityInformation';
import mailingAddress from './mailingAddress';
import personalInformation from './personalInformation';

export const primaryPages = {
  hasPrimaryCaregiver: {
    path: 'primary-caregiver/apply-for-benefits',
    title: content['primary-info-title--apply'],
    ...hasPrimary,
  },
  primaryPersonalInfo: {
    path: 'primary-caregiver/personal-information',
    title: content['primary-info-title--personal'],
    depends: hasPrimaryCaregiver,
    ...personalInformation,
  },
  primaryIdentityInfo: {
    path: 'primary-caregiver/identity-information',
    title: content['primary-info-title--id'],
    depends: hasPrimaryCaregiver,
    ...identityInformation,
  },
  primaryAddressSelection: {
    path: 'primary-caregiver-address-selection',
    title: content['primary-address--selection-title'],
    depends: hasPrimaryCaregiver,
    ...addressSelection,
  },
  primaryHomeAddress: {
    path: 'primary-caregiver/home-address',
    title: content['primary-info-title--address-home'],
    depends: whenAll(hasPrimaryCaregiver, hasNoSharedAddress('primary')),
    ...homeAddress,
  },
  primaryMailingAddress: {
    path: 'primary-caregiver-mailing-address',
    title: content['primary-info-title--address-mailing'],
    depends: whenAll(
      hasPrimaryCaregiver,
      hasDifferentMailingAddress('primary'),
    ),
    ...mailingAddress,
  },
  primaryContactInfo: {
    path: 'primary-caregiver/contact-information',
    title: content['primary-info-title--contact'],
    depends: hasPrimaryCaregiver,
    ...contactInformation,
  },
};
